import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePaymentStore = defineStore('paymentstore', () => {
  const amount        = ref(null)
  const client_secret = ref(null)
  const id            = ref(null)
  const intent_id     = ref(null)

  const update = (order) => {
    amount.value        = order?.amount ?? null
    client_secret.value = order?.client_secret ?? null
    id.value            = order?.id ?? null
    intent_id.value     = order?.intent_id ?? null
  }

  const resetData = () => {
    amount.value        = null
    client_secret.value = null
    id.value            = null
    intent_id.value     = null
  }

  return {
    amount,
    client_secret,
    id,
    intent_id,
    resetData,
    update,
  }
}, { persist:true })
